import { render, staticRenderFns } from "./collapsePanel.vue?vue&type=template&id=0a455b4e&scoped=true"
import script from "./collapsePanel.vue?vue&type=script&lang=js"
export * from "./collapsePanel.vue?vue&type=script&lang=js"
import style0 from "./collapsePanel.vue?vue&type=style&index=0&id=0a455b4e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a455b4e",
  null
  
)

export default component.exports